// src/pages/MyResume.js
import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import useProtectedRoute from '../hooks/useProtectedRoute';
import Menu from '../components/Menu';
import Footer from '../components/Footer';
import ResumeForm from '../components/ResumeForm';

const MyResume = () => {
  const isLoggedIn = useProtectedRoute();
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) setUserId(user.uid);
    });
    return () => unsubscribe();
  }, []);

  if (!isLoggedIn) return null;

  return (
    <>
      <Menu isLoggedIn={isLoggedIn} />
      <div className="bg-gray-50 min-h-screen pb-12">
        {userId && <ResumeForm userId={userId} />}
      </div>
      <Footer />
    </>
  );
};

export default MyResume;
